import React, { useState } from "react";
import "./styles.less";
import { Header } from "../../components/Header";
import { Footer } from "../../components/FooterV2";
import { ManufacturingBanner } from "./components/ManufacturingBanner";
import { ManufacturingMarquee } from "./components/ManufacturingMarquee";
import { ManufacturingPlight } from "./components/ManufacturingPlight";
import { ManufacturingChart } from "./components/ManufacturingChart";
import { ManufacturingQuestion } from "./components/ManufacturingQuestion";
import { ManufacturingAdvantage } from "./components/ManufacturingAdvantage";
import { ManufacturingProductivity } from "./components/ManufacturingProductivity";
import { ManufacturingOther } from "./components/ManufacturingOther";
import { SolutionProduct } from "../../components/SolutionProduct";

export const Manufacturing = (props) => {
  return (
    <div className="manufacturing">
      <Header mode="light" special />
      <ManufacturingBanner />
      <ManufacturingMarquee />
      <ManufacturingPlight />
      <ManufacturingChart />
      <ManufacturingQuestion />
      <ManufacturingAdvantage />
      {/* <ManufacturingProductivity /> */}
      <SolutionProduct />
      <ManufacturingOther />
      <Footer />
    </div>
  );
};
